// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetTECMessagesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";

export function getTECMessagesDataView(state: ApplicationState, parameter: GetTECMessagesApiParameter) {
    return getDataView(state.greif.data.tecMessages, parameter);
}
